<form name="exameditorform">
  <h3 ng-bind="vm.exam.template.displayname"></h3>

  <div class=" spacer-top"></div>
  <!-- exam images/files -->
  <examfiles examid="vm.exam._id" ng-if="vm.exam.template.loadfiles === true"></examfiles>
  <examgdtfiles examid="vm.exam._id" ng-if="vm.exam.template.isgdt === true"></examgdtfiles>
<!--  <examdicomfiles examid="vm.exam._id" ng-if="vm.exam.template.isdicom === true"></examdicomfiles>-->

  <div class=" spacer-top"></div>
  <!-- fieldgroups -->
  <div ng-repeat="fieldgroup in vm.exam.template.fieldgroups">
    <fieldgroup fieldgroup="fieldgroup" gi="{{$index}}" on-fieldgroup-change="vm.save()"></fieldgroup>
  </div>


  <!-- Biopsy fields -->
  <!-- biopsy format in db
      "biopsy" : {
        "label" : "Biopsien",
        "values" : [
          {
            "name" : "Magenpförtner"
          },
          {
            "name" : "Magenrückwand"
          }
        ],
        "biopsies" : [
          {
            "label" : "",
            "avalues" : "",
            "values" : ""
          }
        ]
      }
  -->


  <!-- Biopsy fields -->
  <div ng-show="vm.exam.template.biopsy" class="panel panel-default">
    <div class="panel-heading"><h4>Biopsien</h4></div>
    <div class="panel-body">


      <div ng-show="vm.exam.open === true">
        <!-- biopsy referral doctor -->
        <label for="patho">Labor/Pathologie</label>
        <div class="form-group" ng-hide="vm.exam.template.biopsy.pathology._id">
          <doctorsearch doctor="vm.exam.template.biopsy.pathology"
                        doctorref="vm.exam.template.biopsy.pathologyref"
                        parentsave="vm.saveDoctor(doctor)"></doctorsearch>
        </div>
        <div class="form-group" ng-show="vm.exam.template.biopsy.pathology._id">
          <div class="input-group">
            <input type="text" class="form-control"
                   readonly
                   ng-model="vm.exam.template.biopsy.pathology.fname">
            <span class="input-group-btn">
                  <button class="btn btn-danger"
                          ng-click="vm.clearDoctor()"><i class="fa fa-remove"></i>
                  </button>
              </span>
          </div>
        </div>

        <!-- biopsy referral fields -->
        <label for="pathdiag">Diagnose/Begründung</label>
        <input type="text" tabindex="901" id="pathdiag" class="form-control"
               ng-blur="vm.save()"
               ng-model="vm.exam.template.biopsy.pathdiag">

        <label for="pathcomment">Kommentar/Anweisung</label>
        <textarea tabindex="901" id="pathcomment" class="form-control"
                  ng-blur="vm.save()"
                  ng-model="vm.exam.template.biopsy.pathcomment"></textarea>


      </div>

      <div ng-hide="vm.exam.open === true">
        <label for="patho">Labor/Pathologie
          <sprhelp tip="Überweisungen" descref="vm.sprref"></sprhelp>
        </label>
        <div class="form-group" ng-show="vm.exam.template.biopsy.pathology._id">
          <input type="text" class="form-control"
                 readonly
                 ng-model="vm.exam.template.biopsy.pathology.fname">
        </div>
      </div>

      <!-- Biopsy fields -->
      <biopsyfield field="bf" bvalues="vm.exam.template.biopsy.values" on-field-change="vm.save()"
                   ng-init="bf.label  = 'PE ' + ($index + 1) + ' ' + vm.exam.template.type"
                   ng-repeat="bf in vm.exam.template.biopsy.biopsies">
      </biopsyfield>


      <!-- biopsy buttons -->
      <div class="form-group spacer-top">
        <button type="submit" class="btn btn-success"
                ng-click="vm.addBiopsyField()">
          <i class="fa fa-plus"></i> Biopsiefeld hinzufügen
        </button>

        <button type="submit" class="btn btn-primary" ng-class="{'btn-success': vm.labelsprinted}"
                ng-click="vm.printBiopsyLabels()">
          <span ng-show="!vm.labelsprinted"><i class="fa fa-print"></i>&nbsp;Etiketten drucken</span>
          <span ng-show="vm.labelsprinted"><i class="fa fa-check"></i>&nbsp;Etiketten gedruckt</span>
        </button>

        <a class="btn btn-info" target="_blank"
           href="/routes/fop/examlabels/false/false/{{vm.exam._id}}">
          <i class="fa fa-eye"></i> Etiketten als PDF
        </a>
      </div>
    </div>
  </div> <!-- Biopsy group-->

  <h4>Meßwerte erfassen</h4>
  <trackervaluenew trackerid="tracker._id" clientid="vm.exam.patientid" onentrycb="vm.addTrackerValue(trackervalue)"
                   class="spacer-top" ng-repeat="tracker in vm.exam.template.trackers"></trackervaluenew>




  <div class=" spacer-top"></div>
  <!-- special fields -->
  <div class="panel panel-default" ng-if="vm.exam.template.includefindings !== true">
    <div class="panel-heading"><h4>Befundzusammenfassung</h4></div>
    <div class="panel-body">
      <examfield field="vm.exam.template.diagnosis" on-field-change="vm.save()"
                 ng-show="vm.exam.template.diagnosis"></examfield>
      <examfield field="vm.exam.template.recommendation" on-field-change="vm.save()"
                 ng-show="vm.exam.template.recommendation"></examfield>
      <examfield field="vm.exam.template.comment" on-field-change="vm.save()"
                 ng-show="vm.exam.template.comment"></examfield>
    </div>
  </div>

  <div class="spacer-top spacer-bottom" ng-if="vm.exam.open === true">
    <a class="btn btn-info" href="{{vm.previewUrl}}" target="_blank"><i class="fa fa-eye"></i> Befundvorschau</a>
  </div>


  <div class="spacer-top spacer-bottom" ng-if="vm.exam.open === true">
    <div class="btn btn-warning" ng-click="vm.finishExam(vm.exam)">Untersuchung abschließen</div>
  </div>


</form> <!-- exam editor form -->
